// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
    position: absolute;
    width: 3.8px;
    height: 3.8px;
    opacity: 0.5;
}

.spinner div {
    position: absolute;
    width: 50%;
    height: 150%;
    background: #2f3e46;
    transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1%));
    animation: spinner-fzua35 1s calc(var(--delay) * 1s) infinite ease;
}

.spinner div:nth-child(1) {
    --delay: 0.1;
    --rotation: 36;
    --translation: 150;
}

.spinner div:nth-child(2) {
    --delay: 0.2;
    --rotation: 72;
    --translation: 150;
}

.spinner div:nth-child(3) {
    --delay: 0.3;
    --rotation: 108;
    --translation: 150;
}

.spinner div:nth-child(4) {
    --delay: 0.4;
    --rotation: 144;
    --translation: 150;
}

.spinner div:nth-child(5) {
    --delay: 0.5;
    --rotation: 180;
    --translation: 150;
}

.spinner div:nth-child(6) {
    --delay: 0.6;
    --rotation: 216;
    --translation: 150;
}

.spinner div:nth-child(7) {
    --delay: 0.7;
    --rotation: 252;
    --translation: 150;
}

.spinner div:nth-child(8) {
    --delay: 0.8;
    --rotation: 288;
    --translation: 150;
}

.spinner div:nth-child(9) {
    --delay: 0.9;
    --rotation: 324;
    --translation: 150;
}

.spinner div:nth-child(10) {
    --delay: 1;
    --rotation: 360;
    --translation: 150;
}

@keyframes spinner-fzua35 {

    0%,
    10%,
    20%,
    30%,
    50%,
    60%,
    70%,
    80%,
    90%,
    100% {
        transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1%));
    }

    50% {
        transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1.5%));
    }
}

.spinner-container {
    display: none;
    /* display: inline-block; */
    position: relative;
    width: 45px;
}

.spinner-container .spinner {
    left: 50%;
    top: 40%;
}`, "",{"version":3,"sources":["webpack://./src/app/css/spinner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,2FAA2F;IAC3F,kEAAkE;AACtE;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI;;;;;;;;;;QAUI,2FAA2F;IAC/F;;IAEA;QACI,6FAA6F;IACjG;AACJ;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ","sourcesContent":[".spinner {\n    position: absolute;\n    width: 3.8px;\n    height: 3.8px;\n    opacity: 0.5;\n}\n\n.spinner div {\n    position: absolute;\n    width: 50%;\n    height: 150%;\n    background: #2f3e46;\n    transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1%));\n    animation: spinner-fzua35 1s calc(var(--delay) * 1s) infinite ease;\n}\n\n.spinner div:nth-child(1) {\n    --delay: 0.1;\n    --rotation: 36;\n    --translation: 150;\n}\n\n.spinner div:nth-child(2) {\n    --delay: 0.2;\n    --rotation: 72;\n    --translation: 150;\n}\n\n.spinner div:nth-child(3) {\n    --delay: 0.3;\n    --rotation: 108;\n    --translation: 150;\n}\n\n.spinner div:nth-child(4) {\n    --delay: 0.4;\n    --rotation: 144;\n    --translation: 150;\n}\n\n.spinner div:nth-child(5) {\n    --delay: 0.5;\n    --rotation: 180;\n    --translation: 150;\n}\n\n.spinner div:nth-child(6) {\n    --delay: 0.6;\n    --rotation: 216;\n    --translation: 150;\n}\n\n.spinner div:nth-child(7) {\n    --delay: 0.7;\n    --rotation: 252;\n    --translation: 150;\n}\n\n.spinner div:nth-child(8) {\n    --delay: 0.8;\n    --rotation: 288;\n    --translation: 150;\n}\n\n.spinner div:nth-child(9) {\n    --delay: 0.9;\n    --rotation: 324;\n    --translation: 150;\n}\n\n.spinner div:nth-child(10) {\n    --delay: 1;\n    --rotation: 360;\n    --translation: 150;\n}\n\n@keyframes spinner-fzua35 {\n\n    0%,\n    10%,\n    20%,\n    30%,\n    50%,\n    60%,\n    70%,\n    80%,\n    90%,\n    100% {\n        transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1%));\n    }\n\n    50% {\n        transform: rotate(calc(var(--rotation) * 1deg)) translate(0, calc(var(--translation) * 1.5%));\n    }\n}\n\n.spinner-container {\n    display: none;\n    /* display: inline-block; */\n    position: relative;\n    width: 45px;\n}\n\n.spinner-container .spinner {\n    left: 50%;\n    top: 40%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
